import { render, staticRenderFns } from "./CorporatePage.vue?vue&type=template&id=fc83384e&scoped=true"
import script from "./CorporatePage.vue?vue&type=script&lang=js"
export * from "./CorporatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc83384e",
  null
  
)

export default component.exports